import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";

const LlegoAlDestino = ({ open, onClose, data, getRegulador, showToast }) => {
  const { id_regulador: id, sucursal, sucursal_destino } = data;

  const handleSaveChanges = async () => {
    const response = await fetch(
      `${UrlApi}/reguladores_abm/cambioDeSucursal/llegoAlDestino/${id}`,
      {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sucursal_origen: sucursal, sucursal_destino }),
        method: "PUT",
      }
    );

    if (!response.ok) {
      showToast(
        "Ocurrio un error al indicar que el regulador llego a destino",
        "error"
      );
      return;
    } else {
      showToast(
        "El cambio se realizo correctamente. Se cambio el estado del regulador a `En planta`",
        "success"
      );
      getRegulador();
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle
        sx={{ color: "#fff" }}
        id="customized-dialog-title"
        backgroundColor="#1F618D"
        p={1.5}
      >
        ¿El regulador llegó a destino?
      </DialogTitle>

      <DialogContent dividers>
        <Typography>
          Si la respuesta es afirmativa, volverá a la sección "En planta" y
          podrá ser asignado a un cliente.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ display: "felx", justifyContent: "end" }}>
        <Button
          autoFocus
          onClick={onClose}
          variant="contained"
          color="error"
          sx={{ width: "150px" }}
        >
          Volver
        </Button>
        <Button
          autoFocus
          onClick={handleSaveChanges}
          variant="contained"
          color="primary"
          sx={{ width: "150px" }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LlegoAlDestino;
